import { styled } from "@mui/material";

export const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
});